export class ExerciseModel {
    constructor(exerciseData) {
        this._exercise = {
            exerciseId: exerciseData.exercise_id,
            name: exerciseData.name,
            exerciseType: exerciseData.exerciseType,
            METvalue: exerciseData.MET_value,
            asKgLifted: exerciseData.as_KG_lifted,
            exampleYoutubeLink: exerciseData.example_youtube_link,
            youtubeLink: exerciseData.youtube_link,
            iconName: exerciseData.icon_name,
            isDistanceRequired: exerciseData.is_distance_required,
            distance: exerciseData.distance,
            deafultSetLength: exerciseData.default_set_length_s,
            defaultRestBetweenSets: exerciseData.default_rest_between_sets,
            defaultRepsPerSet: exerciseData.default_reps_per_set,
            asPOfBodyweight: exerciseData.as_p_of_bodyweight,
            whiteImage: exerciseData.white_image_url,
            orangeImage: exerciseData.orange_image_url,
        };
    }

    get exercise() {
        return this._exercise;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/ExerciseModel.js